<template>
  <div class="f-column">
    <GwTitleTooltip
      v-if="hasTitle"
      class="mt-2 theme-block-title"
      :title="$t('settings.range_eq_buckets_style_title')"
      :tooltip="$t('tooltips.range_eq_buckets_style_title')"
    />
    <div
      v-if="hasOptions"
      class="d-flex"
    >
      <GwBtns
        :options="[
          { id: 'two', text: $t('settings.range_eq_buckets_style_two') },
          { id: 'one', text: $t('settings.range_eq_buckets_style_one') },
        ]"
        :value="styleEqBuckets"
        idKey="id"
        class="gwbtns_horizontal_grey"
        style="
          background: var(--clr-black-1-3);
          border-radius: 4px;
          --gwbtn-size: 1rem;
          --gwbtn-height: 1.875rem;
          --gwbtns-wrap: wrap;
          --gwbtns-padding: 2px;
        "
        @click="
          (_e, item) => {
            styleEqBuckets = item.id
          }
        "
      >
        <template #default="{ item }">
          {{ item.text }}
        </template>
      </GwBtns>
    </div>

    <div
      v-if="hasPreview"
      :class="{ 'mt-2': hasOptions }"
    >
      <CompareChartBox
        class="ursetappr_preview"
        :style="`
Z        --weight: 700;
        --weight-legend: 700;
        --size-legend-center: 0.8rem;
        --clr-equal:var(--clr-primary)
      `"
        :isCentered="styleEqBuckets === 'two'"
        :hasColoredLegend="true"
        :isHoverable="false"
        :skeleton="false"
        :pLeft="0.4"
        :pRight="0.6"
        :flipped="false"
      >
        <template #legend_left> 40 % </template>
        <template #legend_center>
          <div
            class="uppercase text-nowrap truncate clr-grey"
            style="max-width: 10rem"
            :title="$t(`browse.eq_buckets.best_hands`)"
          >
            {{ $t(`browse.eq_buckets.best_hands`) }}
          </div>
        </template>
        <template #legend_right> 60 % </template>
      </CompareChartBox>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import CompareChartBox from '@/components/Charts/CompareChartBox/CompareChartBox'
import GwBtns from '@/components/lib/GwBtns'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SettingsStudyStyles',
  components: {
    GwTitleTooltip,
    CompareChartBox,
    GwBtns,
  },
  mixins: [float_mix],
  props: {
    hasTitle: { type: Boolean, default: true },
    hasOptions: { type: Boolean, default: true },
    hasPreview: { type: Boolean, default: true },
  },
  data() {
    return {}
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/img/${img}.webp`, import.meta.url).href
    },
  },

  computed: {
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    mergedUserSettings() {
      const { mergedUserSettings } = this.$store.getters
      return mergedUserSettings
    },
    styleEqBuckets: {
      get() {
        const res = this.mergedUserSettings.styleEqBuckets || 'one'
        return res
      },
      set(value) {
        this.$store.dispatch('userSettings', { styleEqBuckets: value })
      },
    },
  },
}
</script>
